import { ChangeEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, TextField } from '@mui/material';

import { actions } from 'main/store/schedule/reducer';
import { EVENT_TYPE, EventType } from 'main/store/schedule/state';
import { selectEventDialogDataType } from "main/store/schedule/selectors";

export const EventTypeSelect = () => {
    const dispatch = useDispatch();
    const value = useSelector(selectEventDialogDataType);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        dispatch(actions.changeEventDialogDataType(event.target.value as EventType));
    }, [dispatch]);

    return (
        <TextField select label="タイプ" value={value} fullWidth onChange={handleChange}>
            {Object.values(EVENT_TYPE).map(type =>
                <MenuItem key={type} value={type}>{type}</MenuItem>
            )}
        </TextField>
    )
}
